import invariant from 'invariant'
import { isFSA } from 'flux-standard-action'
import {
  REPORTS_SET_LIST_SALES_SUMMARY,
  REPORTS_SET_SALES_TYPE,
  REPORTS_SET_LIST_GROSS_PROFIT,
  REPORTS_SET_PAYMENT_METHODS,
  REPORTS_SET_ITEM_SALES,
  REPORTS_SET_CATEGORY_SALES,
  REPORTS_SET_MODIFIER_SALES,
  REPORTS_SET_DISCOUNTS,
  REPORTS_SET_TAXES,
  REPORTS_SET_GRATUITY,
  REPORTS_SET_COLLECTEDBY,
  REPORTS_SET_SERVEDBY,
  REPORTS_SALES_SUMMARY_SET_START_END_DATE,
  REPORTS_SALES_TYPE_SET_START_END_DATE,
  REPORTS_SALES_PAYMENT_METHODS_SET_START_END_DATE,
  REPORTS_SALES_ITEM_SALES_SET_START_END_DATE,
  REPORTS_SALES_CATEGORY_SALES_SET_START_END_DATE,
  REPORTS_SALES_MODIFIER_SALES_SET_START_END_DATE,
  REPORTS_SALES_DISCOUNTS_SET_START_END_DATE,
  REPORTS_SALES_TAXES_SET_START_END_DATE,
  REPORTS_SALES_GRATUITY_SET_START_END_DATE,
  REPORTS_SALES_COLLECTEDBY_SET_START_END_DATE,
  REPORTS_SALES_SERVEDBY_SET_START_END_DATE,
  REPORTS_SALES_SET_OUTLETS,
  REPORTS_SALES_SHOW_LOADING_SPINNER
} from 'actions/reports/sales/constants'
import moment from 'moment'

let initialState = {
  sales: [], // sales summary,
  sales_type: [],
  gross_profit: [],
  paymentMethods: {
    total_number_of_transactions: 0,
    total_collected: 0,
    reports: {
      cash_or_card: [],
      invoice: [],
      other: []
    }
  },
  itemSales: [],
  categorySales: [],
  modifierSales: [],
  discounts: [],
  taxes: {reports_taxes: [], total_tax_collected: 0},
  gratuities: {reports_gratuities: [], total_gratuity_collected: 0},
  staffs: {staff_reports: {}, total_transaction_amount: 0, total_transaction_count: 0},
  servers: {servers: [], total_collected: 0, total_number_transaction: 0},
  startDate: moment().add(-1, 'years').startOf('year'),
  endDate: moment().add(-1, 'years').endOf('year'),
  outlets: [],
  showLoadingSpinnerReport: false
}

function reducer (state = initialState, action) {
  invariant(
    isFSA(action),
    `Invalid FSA action. See https://github.com/acdlite/flux-standard-action for info. Object: ${JSON.stringify(action)}`
  )
  const {payload = {}} = action
  switch (action.type) {
    case REPORTS_SET_LIST_SALES_SUMMARY:
      return {...state, sales: payload.sales}
    case REPORTS_SET_SALES_TYPE:
      return {...state, sales_type: payload.salesTypes}
    case REPORTS_SET_LIST_GROSS_PROFIT:
      return {...state, gross_profit: payload.grossProfit}
    case REPORTS_SET_PAYMENT_METHODS:
      return {...state, paymentMethods: payload.paymentMethods}
    case REPORTS_SET_ITEM_SALES:
      return {...state, itemSales: payload.itemSales}
    case REPORTS_SET_CATEGORY_SALES:
      return {...state, categorySales: payload.categorySales}
    case REPORTS_SET_MODIFIER_SALES:
      return {...state, modifierSales: payload.modifierSales}
    case REPORTS_SET_DISCOUNTS:
      return {...state, discounts: payload.discounts}
    case REPORTS_SET_TAXES:
      return {...state, taxes: payload.taxes}
    case REPORTS_SET_GRATUITY:
      return {...state, gratuities: payload.gratuities}
    case REPORTS_SET_COLLECTEDBY:
      return {...state, staffs: payload.staffs}
    case REPORTS_SET_SERVEDBY:
      return {...state, servers: payload.servers}
    case REPORTS_SALES_SUMMARY_SET_START_END_DATE:
      return {...state, startDate: payload.startDate, endDate: payload.endDate}
    case REPORTS_SALES_TYPE_SET_START_END_DATE:
      return {...state, startDate: payload.startDate, endDate: payload.endDate}
    case REPORTS_SALES_PAYMENT_METHODS_SET_START_END_DATE:
      return {...state, startDate: payload.startDate, endDate: payload.endDate}
    case REPORTS_SALES_ITEM_SALES_SET_START_END_DATE:
      return {...state, startDate: payload.startDate, endDate: payload.endDate}
    case REPORTS_SALES_CATEGORY_SALES_SET_START_END_DATE:
      return {...state, startDate: payload.startDate, endDate: payload.endDate}
    case REPORTS_SALES_MODIFIER_SALES_SET_START_END_DATE:
      return {...state, startDate: payload.startDate, endDate: payload.endDate}
    case REPORTS_SALES_DISCOUNTS_SET_START_END_DATE:
      return {...state, startDate: payload.startDate, endDate: payload.endDate}
    case REPORTS_SALES_TAXES_SET_START_END_DATE:
      return {...state, startDate: payload.startDate, endDate: payload.endDate}
    case REPORTS_SALES_GRATUITY_SET_START_END_DATE:
      return {...state, startDate: payload.startDate, endDate: payload.endDate}
    case REPORTS_SALES_COLLECTEDBY_SET_START_END_DATE:
      return {...state, startDate: payload.startDate, endDate: payload.endDate}
    case REPORTS_SALES_SERVEDBY_SET_START_END_DATE:
      return {...state, startDate: payload.startDate, endDate: payload.endDate}
    case REPORTS_SALES_SET_OUTLETS:
      return {...state, outlets: payload.outlets}
    case REPORTS_SALES_SHOW_LOADING_SPINNER:
      return {...state, showLoadingSpinnerReport: payload.showLoadingSpinnerReport}
    default:
      return {...state}
  }
}

export {reducer}



// WEBPACK FOOTER //
// ./app/reducers/reports/sales.js